import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import LogoutButton from "./LogoutButton";
import AvatarPicker from "./AvatarPicker";
import { updateProfile } from "firebase/auth";

const availableAnthems = [
    { id: "anthem1", name: "Гимн 1", url: "/audio/anthem1.mp3" },
    { id: "anthem2", name: "Гимн 2", url: "/audio/anthem2.mp3" },
    { id: "anthem3", name: "Гимн 3", url: "/audio/anthem3.mp3" },
    { id: "anthem4", name: "Гимн 4", url: "/audio/anthem4.mp3" },
    { id: "anthem5", name: "Гимн 5", url: "/audio/anthem5.mp3" },
    { id: "anthem6", name: "Гимн 6", url: "/audio/anthem6.mp3" },
];

const EditProfile = () => {
    const { currentUser } = useAuth();
    const [displayName, setDisplayName] = useState("");
    const [bio, setBio] = useState("");
    const [selectedAvatar, setSelectedAvatar] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedAnthem, setSelectedAnthem] = useState("");

    useEffect(() => {
        if (!currentUser) return;

        const fetchProfile = async () => {
            const docRef = doc(db, "users", currentUser.uid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data();
                setDisplayName(data.displayName || "");
                setBio(data.bio || "");
                setSelectedAvatar(data.avatarUrl || "");
                setSelectedAnthem(data.anthem || ""); // добавляем загрузку гимна
            }
        };

        fetchProfile();
    }, [currentUser]);

    const handleSave = async (e) => {
        e.preventDefault();
        if (!currentUser) return;
        setLoading(true);

        try {
            // 1. Обновляем в Firestore
            const docRef = doc(db, "users", currentUser.uid);
            await setDoc(
                docRef,
                {
                    displayName, bio, avatarUrl: selectedAvatar,
                    anthem: selectedAnthem, // сохраняем выбранный гимн
                },
                { merge: true }
            );

            // 2. Обновляем в Firebase Auth
            await updateProfile(currentUser, {
                displayName: displayName,
                photoURL: selectedAvatar || null,
            });

            // Обновляем данные пользователя вручную
            await currentUser.reload();


            setMessage("Профиль сохранён!");
        } catch (err) {
            setMessage("Ошибка: " + err.message);
        }

        setLoading(false);
    };


    return (
        <div >
            <form
                onSubmit={handleSave}
                style={{ maxWidth: "1000px", margin: "0 auto" }} className="background-personalWall"
            >
                <h2 className="wall-header">Редактировать профиль <LogoutButton /></h2>

                <input
                    type="text"
                    placeholder="Имя"
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    className=""
                />

                <textarea
                    placeholder="О себе"
                    value={bio}
                    onChange={(e) => setBio(e.target.value)}
                    className=""
                />

                {/* Крупный выбранный аватар */}
                {selectedAvatar && (
                    <div>
                        <img
                            src={selectedAvatar}
                            alt="Выбранный аватар"
                            className="w-24 h-24 rounded-full border-4 border-neonPink"
                        />
                    </div>
                )}

                {/* Компонент выбора аватара */}
                <AvatarPicker
                    selectedAvatar={selectedAvatar}
                    onSelect={setSelectedAvatar}
                />
                <label className="dateText">Выберите гимн:</label>
                <select
                    value={selectedAnthem}
                    onChange={(e) => setSelectedAnthem(e.target.value)}
                    className="nickname"
                >
                    <option value="">Без гимна</option>
                    {availableAnthems.map((anthem) => (
                        <option key={anthem.id} value={anthem.id}>
                            {anthem.name}
                        </option>
                    ))}
                </select>
                <button
                    type="submit"
                    disabled={loading}
                >
                    {loading ? "Сохраняем..." : "Сохранить"}
                </button>

                {message && <p className="text-neonPink">{message}</p>}
            </form>
        </div>
    );
};

export default EditProfile;
